import React, { useEffect, useMemo, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import Botao from '../egora/Botao';
import { gruposVisiveis, moduloDaRota } from './navegacao';
import { abrirPerfil } from './perfil';
import { iniciais } from './iniciais';
import './casca.css';

/**
 * Barra superior (Home.dc.html, opção de Preferências): os grupos, cada um com a
 * lista dos módulos; Alertas como item direto; à direita Configurações e o perfil.
 * Nada desliza nem rola.
 */
export default function BarraSuperior() {
  const { usuarioLogado, temPermissao, logout } = useAuth();
  const { pathname } = useLocation();

  const grupos = useMemo(() => gruposVisiveis(temPermissao, usuarioLogado), [temPermissao, usuarioLogado]);
  const atual = moduloDaRota(pathname, grupos);
  const gruposDaBarra = grupos.filter((g) => g.id !== 'comunicacao' && g.id !== 'configuracoes');
  const alertas = grupos.find((g) => g.id === 'comunicacao')?.modulos.find((m) => m.rota === '/alertas');
  const configuracoes = grupos.find((g) => g.id === 'configuracoes')?.modulos.find((m) => m.rota === '/configuracoes');

  const [grupoAberto, setGrupoAberto] = useState(null);
  const [perfilAberto, setPerfilAberto] = useState(false);
  const algoAberto = grupoAberto !== null || perfilAberto;

  useEffect(() => {
    if (!algoAberto) return undefined;
    const aoApertarTecla = (e) => {
      if (e.key === 'Escape') { setGrupoAberto(null); setPerfilAberto(false); }
    };
    window.addEventListener('keydown', aoApertarTecla);
    return () => window.removeEventListener('keydown', aoApertarTecla);
  }, [algoAberto]);

  const fechar = () => { setGrupoAberto(null); setPerfilAberto(false); };

  return (
    <nav className="sj-barra casca-barra-superior" aria-label="Principal">
      <img className="sj-menu__logo casca-barra-superior__logo" src="/marca/egora-icone-claro.png" alt="EGORA" />

      {gruposDaBarra.map((grupo) => {
        const aberto = grupoAberto === grupo.id;
        return (
          <div key={grupo.id} className="sj-barra__grupo">
            <Botao
              variante="fantasma"
              className="sj-barra__botao"
              aria-haspopup="true"
              aria-expanded={aberto}
              aria-current={atual?.grupo.id === grupo.id ? 'page' : undefined}
              onClick={() => { setPerfilAberto(false); setGrupoAberto(aberto ? null : grupo.id); }}
            >
              {grupo.rotulo}
              <span className="sj-icone sj-icone--sm" aria-hidden="true">expand_more</span>
            </Botao>
            {aberto && (
              <div className="sj-lista">
                {grupo.modulos.map((m) => (
                  <NavLink key={m.rota} to={m.rota} className="sj-lista__item" onClick={fechar}>{m.rotulo}</NavLink>
                ))}
              </div>
            )}
          </div>
        );
      })}

      {alertas && (
        <div className="sj-barra__grupo">
          <NavLink to="/alertas" className="sj-barra__botao casca-barra-superior__link" aria-current={atual?.modulo.rota === '/alertas' ? 'page' : undefined}>
            <span className="sj-icone" aria-hidden="true">notifications_active</span>Alertas
          </NavLink>
        </div>
      )}

      <div className="sj-barra__direita">
        {configuracoes && (
          <NavLink to="/configuracoes" className="sj-btn sj-btn--fantasma sj-btn--icone" aria-label="Configurações" title="Configurações">
            <span className="sj-icone" aria-hidden="true">settings</span>
          </NavLink>
        )}
        <div className="sj-barra__grupo">
          <Botao
            variante="fantasma"
            className="sj-barra__botao"
            aria-label={`Menu do perfil de ${usuarioLogado.nome}`}
            aria-haspopup="menu"
            aria-expanded={perfilAberto}
            onClick={() => { setGrupoAberto(null); setPerfilAberto((v) => !v); }}
          >
            <span className="sj-avatar">{iniciais(usuarioLogado.nome)}</span>
          </Botao>
          {perfilAberto && (
            <div className="sj-lista sj-lista--direita" role="menu">
              <Botao item role="menuitem" onClick={() => { fechar(); abrirPerfil(); }}>
                <span className="sj-icone" aria-hidden="true">person</span>Ver perfil
              </Botao>
              <Botao item role="menuitem" onClick={() => { fechar(); abrirPerfil('preferencias'); }}>
                <span className="sj-icone" aria-hidden="true">tune</span>Preferências
              </Botao>
              <Botao item role="menuitem" onClick={() => { fechar(); logout(); }}>
                <span className="sj-icone" aria-hidden="true">logout</span>Sair
              </Botao>
            </div>
          )}
        </div>
      </div>

      {algoAberto && <div className="sj-camada" onClick={fechar} aria-hidden="true" />}
    </nav>
  );
}
